// API Configuration and Settings
export const API_CONFIG = {
    OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY || (() => {
        return 'your-openai-api-key-here';
    })(),
    BASE_URL: "https://api.openai.com/v1",
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000 // 1 second
};

export const API_ENDPOINTS = {
    OPENAI_CHAT: `${API_CONFIG.BASE_URL}/chat/completions`,
    OPENAI_COMPLETIONS: `${API_CONFIG.BASE_URL}/completions`
};

// API Response Parsing
export const parseOpenAIResponse = async (response) => {
    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`API request failed with status ${response.status}: ${errorBody}`);
    }

    const result = await response.json();
    
    if (result.choices && result.choices.length > 0 &&
        result.choices[0].message && result.choices[0].message.content) {
        return result.choices[0].message.content;
    } else {
        throw new Error("No content generated or unexpected response structure.");
    }
};

// Enhanced API client with retry logic
export const apiClient = {
    async generateContent(prompt, model = 'gpt-3.5-turbo', options = {}) {
        const messages = [{ role: "user", content: prompt }];
        const payload = { 
            model: model,
            messages: messages,
            ...options
        };
        
        const apiUrl = API_ENDPOINTS.OPENAI_CHAT;
        
        let lastError;
        for (let attempt = 1; attempt <= API_CONFIG.RETRY_ATTEMPTS; attempt++) {
            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${API_CONFIG.OPENAI_API_KEY}`
                    },
                    body: JSON.stringify(payload)
                });
                
                return await parseOpenAIResponse(response);
            } catch (error) {
                lastError = error;
                
                if (attempt < API_CONFIG.RETRY_ATTEMPTS) {
                    await new Promise(resolve => setTimeout(resolve, API_CONFIG.RETRY_DELAY * attempt));
                }
            }
        }
        
        throw lastError;
    }
}; 